<svg viewBox="0 0 200 115">
  <g transform="translate(0, -10)">
    <g *ngFor="let display of displayArc">
      <path *ngIf="display.pathData" [attr.d]="display.pathData" fill="none" [attr.stroke]="display.colour"
        [attr.stroke-width]="circleRadius * 2" stroke-linecap="round" />
    </g>
    <g [attr.transform]="getNeedleTransform()">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M7.1494 10.4078C7.64032 10.4078 8.09676 10.1724 8.39366 9.78123L13.6224 3.25488C13.8852 2.93212 14.0278 2.52715 14.0278 2.09791C14.0278 1.32575 13.5042 0.338867 12.4115 0.338867C11.9033 0.338867 11.4872 0.587112 11.2177 0.896091L11.2043 0.911454L7.14885 5.96304L3.1001 0.926783L3.09363 0.918907C2.81504 0.579507 2.38567 0.338867 1.88048 0.338867C0.78787 0.338867 0.264194 1.32575 0.264194 2.09791C0.264194 2.53458 0.411028 2.92995 0.656728 3.24688L0.661817 3.25345L5.90879 9.79434L5.91593 9.80304C6.19611 10.1444 6.61821 10.4078 7.1494 10.4078Z"
        fill="#fff" />
    </g>

    <g transform="translate(100, 70)">
      <text *ngIf="percentageChanged" text-anchor="middle" dominant-baseline="middle"
        font-size="var(--bio-guage-percentage-font-size)" font-family="'Open Sans', sans-serif"
        fill="var(--bio-guage-text-color)">{{percentageChanged}}</text>

      <text *ngIf="!percentageChanged" text-anchor="middle" dominant-baseline="middle"
        font-size="var(--bio-guage-percentage-font-size)" font-family="'Open Sans', sans-serif"
        fill="var(--bio-guage-range-color)">{{noChangeText}}</text>

      <g transform="translate(20, -1) scale(0.3)" *ngIf="arrowDirection && arrowDirection=='up'">
        <path
          d="M26.08,1.51c0-.19-.04-.38-.11-.55c0,0,0-.02,0-.02-.15-.37-.45-.67-.82-.82,0,0-.01,0-.02,0-.17-.07-.36-.11-.55-.11H7.61c-.84,0-1.52.68-1.52,1.52s.68,1.52,1.52,1.52h13.3L.44,23.49c-.59.59-.59,1.55,0,2.14.3.3.68.44,1.07.44s.78-.15,1.07-.44L23.05,5.18v13.3c0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52V1.52Z"
          fill="var(--bio-guage-text-color)" transform="translate(-13.04, -13.04)" />
      </g>
      <g transform="translate(20, -1) rotate(180) scale(0.3)" *ngIf="arrowDirection && arrowDirection=='down'">
        <path
          d="M26.08,1.51c0-.19-.04-.38-.11-.55c0,0,0-.02,0-.02-.15-.37-.45-.67-.82-.82,0,0-.01,0-.02,0-.17-.07-.36-.11-.55-.11H7.61c-.84,0-1.52.68-1.52,1.52s.68,1.52,1.52,1.52h13.3L.44,23.49c-.59.59-.59,1.55,0,2.14.3.3.68.44,1.07.44s.78-.15,1.07-.44L23.05,5.18v13.3c0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52V1.52Z"
          fill="var(--bio-guage-text-color)" transform="translate(-13.04, -13.04)" />
      </g>
    </g>

    <g transform="translate(100, 95)">
      <text *ngIf="!displayText" dominant-baseline="middle" text-anchor="middle" font-size="var(--bio-guage-font-size)"
        fill="var(--bio-guage-text-color)">
        {{prefix}}{{ displayedValue }}{{suffix}} {{unitOfMeasure}}
      </text>
      <text *ngIf="displayedValue" dominant-baseline="middle" text-anchor="middle"
        font-size="var(--bio-guage-font-size)" fill="var(--bio-guage-text-color)">
        {{displayText}}
      </text>
    </g>

    <g transform="translate(100, 115)" *ngIf="rangeText">
      <text dominant-baseline="middle" text-anchor="middle" font-size="var(--bio-guage-range-font-size)"
        fill="var(--bio-guage-range-color)">
        {{rangeText}}
      </text>
    </g>
  </g>
</svg>